module.exports = __webpack_public_path__ + "img/11-img.c50f4b4a.jpg";